import capitalize from 'lodash/capitalize';

import { get } from './config';

export interface SelectOption {
    label: string;
    value: string | number;
}

export const fromOptions = <T, >(
    options: T[],
    nameFn: (option: T) => string = (option) => {
        return (option as { name: string }).name;
    },
    idFn: (option: T) => string | number = (option) => {
        return (option as { id: string | number }).id;
    }
): SelectOption[] => {
    return options.map((option) => {
        return {
            label: nameFn(option),
            value: idFn(option),
        };
    });
};

export const toArray = (id: string, labelFn: ((value: string) => string) | null = capitalize): SelectOption[] => {
    const config = get();
    const definition = config.definitions?.[id] as Record<string, string> | undefined;

    if (!definition) {
        return [];
    }

    return Object.keys(definition).map((key) => {
        return {
            label: labelFn ? labelFn(definition[key]) : definition[key],
            value: Number.isNaN(parseInt(key, 10)) ? key : parseInt(key, 10),
        };
    });
};

export const getLabel = (id: string, key: string, labelFn: ((value: string) => string) | null = capitalize): string => {
    const config = get();
    const definition = config.definitions?.[id] as Record<string, string> | undefined;

    if (!definition) {
        return '';
    }

    return labelFn ? labelFn(definition[key]) : definition[key];
};
